// src/components/shared/TopNav.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../../lib/AppContext';
import { t } from '../../lib/i18n';


export default function TopNav() {
  const { lang, cartCount, dispatch, searchQuery, user, isAdmin } = useApp();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const isAdminRoute = pathname.startsWith('/admin');
  useEffect(() => {
  setMenuOpen(false);
}, [pathname]);

  const isActive = (to) => to === '/' ? pathname === '/' : pathname.startsWith(to);

  return (
    <>
      <nav className="topnav">
        <div className="topnav-inner">

          {/* Logo */}
          <div className="topnav-logo" onClick={() => navigate(isAdminRoute ? '/admin' : '/')}>
            <img src="/logo.png" alt="CosmiqHerbz" className="topnav-logo-img" />
          </div>

          {/* Desktop links — only on store pages */}
          {!isAdminRoute && (
            <ul className="topnav-links">
              {[
                { to:'/',        label: t('home', lang) },
                { to:'/blog',    label: 'Blog' },
                { to:'/loyalty', label: t('loyalty', lang) },
                { to:'/wheel',   label: '🎰 Wheel' },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} className={isActive(l.to) ? 'active' : ''}>{l.label}</Link>
                </li>
              ))}
            </ul>
          )}

          {/* Admin breadcrumb on admin pages */}
          {isAdminRoute && (
            <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.8rem', fontWeight:700, letterSpacing:'.18em', textTransform:'uppercase', color:'#4cca74', marginLeft:8 }}>
              Admin Panel
            </span>
          )}

          {/* Right-side controls */}
          <div className="topnav-right">

            {/* Search — store only */}
            {!isAdminRoute && (
              <input
                className="topnav-search"
                type="text"
                placeholder={t('search', lang)}
                value={searchQuery}
                onChange={e => dispatch({ type:'SET_SEARCH', payload:e.target.value })}
                onFocus={() => { if (pathname !== '/search') navigate('/search'); }}
              />
            )}

            {/* Auth buttons */}
            {user ? (
              <Link to="/account" className="topnav-auth-link">
                {t('account', lang)}
              </Link>
            ) : (
              <div className="topnav-auth-btns">
                <Link to="/login" className="topnav-auth-link">
                  {t('login', lang)}
                </Link>
                <Link to="/signup" className="topnav-signup-btn">
                  {t('signup', lang)}
                </Link>
              </div>
            )}

            {/* Admin quick-access pill — visible to admins on store pages */}
            {isAdmin && !isAdminRoute && (
              <Link to="/admin" style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.78rem', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:'#4cca74', textDecoration:'none', background:'rgba(76,202,116,.1)', border:'1px solid rgba(76,202,116,.25)', padding:'6px 12px', borderRadius:'20px', whiteSpace:'nowrap' }}>
                ⚙ Admin
              </Link>
            )}

            {/* Cart — store only */}
            {!isAdminRoute && (
              <button className="cart-btn" onClick={() => dispatch({ type:'CART_TOGGLE' })}>
                🛒
                {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
              </button>
            )}

            {/* Mobile hamburger */}
            {!isAdminRoute && (
              <button
                onClick={() => setMenuOpen(o => !o)}
                className="mobile-menu-toggle"
                aria-label="Toggle menu"
              >
                {menuOpen ? '✕' : '☰'}
              </button>
            )}
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      {menuOpen && !isAdminRoute && (
        <div style={{ position:'fixed', top:'var(--nav-h)', left:0, right:0, background:'#111', borderBottom:'1px solid rgba(255,255,255,.07)', zIndex:199, padding:'8px 0' }}>
          {[{ to:'/', label:t('home',lang) },{ to:'/blog', label:'Blog' },{ to:'/loyalty', label:t('loyalty',lang) },{ to:'/wheel', label:'🎰 Wheel' }].map(l => (
            <Link key={l.to} to={l.to} onClick={() => setMenuOpen(false)} style={{ display:'block', padding:'13px 24px', fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.9rem', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:isActive(l.to)?'#4cca74':'#888', textDecoration:'none', borderBottom:'1px solid rgba(255,255,255,.04)' }}>
              {l.label}
            </Link>
          ))}
          {isAdmin && (
            <Link to="/admin" onClick={() => setMenuOpen(false)} style={{ display:'block', padding:'13px 24px', fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.9rem', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:'#4cca74', textDecoration:'none' }}>
              ⚙ Admin Panel
            </Link>
          )}
        </div>
      )}

    </>
  );
}